/**
 * Created by nijin on 12/12/16.
 */
import { NgModule } from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthComponent} from './auth.component';
import {CookieService} from 'ng2-cookies';

const routes: Routes = [
  {path: '', component: AuthComponent}
];
@NgModule({
    imports: [
      RouterModule.forChild(routes)
    ],
    exports: [RouterModule],
    declarations: [],
    providers: [CookieService],
})
export class AuthRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/auth/auth.routing.module.ts